import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEditinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.526 12.957L.89 15.08l2.196-5.595L11.862.711a1 1 0 0 1 1.418.003l2.03 2.05a1 1 0 0 1-.003 1.412l-8.781 8.781zm-.803-.803L3.89 10.288l-.976 2.825 2.809-.959z",
		fill: "currentColor",
		fillRule: "evenodd"
	})
});
export default SvgEditinline;
